import { createI18n } from "vue-i18n";
import messages from "./translations/translations.json";

type SupportedLocales = "fr" | "en";
export const I18N = createI18n({
  legacy: true,
  locale: getStoredLanguage()
    ? getStoredLanguage()
    : navigator.language === "fr-FR"
      ? "fr"
      : "en",
  fallbackLocale: "fr",
  messages: messages,
  globalInjection: true,
});

export function setLanguage(lang: string) {
  if (["fr", "en"].includes(lang)) {
    (I18N.global as any).locale = lang as SupportedLocales;
  } else {
    (I18N.global as any).locale = "fr";
  }
}

export function getStoredLanguage(): string | null {
  return localStorage.getItem("user-lang");
}

export function setStoredLanguage(lang: string): void {
  localStorage.setItem("user-lang", lang);
}

export function translate(i18nCode: string): string {
  return I18N.global.t(i18nCode);
}
